import React, { forwardRef } from 'react';
import { MenuOptionMobile } from './MenuOptionMobile';
import { ITEM_MENU_OPTIONS } from './Constants';
import {
  getSelectedItems,
  handleSelectedItemsChange,
} from '../../../../../../Services/SelectedItems.service';
import { setOpenedModal } from '../../../../../../Services/Modals.service';
import useObservable from '../../../../../../../Shared/Hooks/useObservable.Hook';
import { downloadItems } from '../../../../../../Services/ItemsDownload.service';
import { setSelectedItems$ } from '../../../../../../Observables/SelectedItems.observable';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { useAppContext } from '../../../../../../Shared/AppContext';

export const ItemActionsMenuMobile = forwardRef(
  ({ setOpen, handleOpenMove, ref }: any) => {
    const { compId } = useAppContext();
    const [, selectedItems]: any = useObservable(getSelectedItems(compId));
    const { t } = useTranslation();
    const handleOpenModal = (type: string) => {
      setOpen && setOpen();
      setOpenedModal(type, compId);
    };
    const handleOnClick = (type: string) => {
      switch (type) {
        case ITEM_MENU_OPTIONS.SELECT_ALL: {
          setOpen && setOpen();
          handleSelectedItemsChange(compId, ITEM_MENU_OPTIONS.SELECT_ALL);
          break;
        }
        case ITEM_MENU_OPTIONS.DESELECT_ALL: {
          setOpen && setOpen();
          setSelectedItems$([], compId);
          break;
        }
        case ITEM_MENU_OPTIONS.DELETE: {
          handleOpenModal(ITEM_MENU_OPTIONS.DELETE);
          break;
        }
        case ITEM_MENU_OPTIONS.MOVE: {
          handleOpenMove && handleOpenMove();
          break;
        }
        case ITEM_MENU_OPTIONS.DOWNLOAD: {
          selectedItems && downloadItems(t, compId);
          break;
        }
        default:
      }
    };
    return (
      <div ref={ref}>
        <MenuOptionMobile handleOnClick={handleOnClick} />
      </div>
    );
  },
);
